import { getLanguageByLocale } from '@diagentech/exprworks-rule-engine';
import { createSelector } from 'reselect';

import { selectLanguages } from '@/features/i18n/selectLanguages';
import { selectLocale } from '@/features/i18n/selectLocale';

export const selectLanguage = createSelector([selectLanguages, selectLocale], (languages, locale) =>
  getLanguageByLocale(languages, locale),
);
